export type BillBuyPartyType = 'stall' | 'orchard'

export const BILL_BUY_PARTY_VALUES = ['stall', 'orchard'] as const satisfies readonly BillBuyPartyType[]

export const BILL_BUY_PARTY_LABELS: Record<BillBuyPartyType, string> = {
  stall: 'หน้าแผง',
  orchard: 'สวน',
}

export const BILL_BUY_PARTY_NAME_LABELS: Record<BillBuyPartyType, string> = {
  stall: 'ชื่อหน้าแผง',
  orchard: 'ชื่อสวน',
}

export const BILL_BUY_PARTY_NAME_PLACEHOLDERS: Record<BillBuyPartyType, string> = {
  stall: 'กรอกชื่อหน้าแผง',
  orchard: 'กรอกชื่อสวน',
}

export function isBillBuyPartyType(v: unknown): v is BillBuyPartyType {
  return v === 'stall' || v === 'orchard'
}

export function normalizeBillBuyPartyType(v: unknown): BillBuyPartyType {
  return isBillBuyPartyType(v) ? v : 'orchard'
}
